import AppData from "../pacakge/public/const/app_data";

const { ccclass, property } = cc._decorator;

@ccclass
export default class CenterHorizontLayout extends cc.Component {

    @property(cc.ScrollView)
    scrollView: cc.ScrollView = null
    @property(cc.Layout)
    layout: cc.Layout = null
    @property
    cellWidth: number = 100
    @property
    offsetX: number = 0
    _scrollWidth = 0


    setLength(length) {
        let widget = this.scrollView.node.getComponent(cc.Widget)
        if(!widget){
            return
        }
        if (AppData.isWidescreen) {
            widget.right = 15 + AppData.widescreenOffset
        }else{
            widget.right = 15
        }
    }


    // setLength(length) {
    //     let offset = 0
    //     if (AppData.isIphoneX) {
    //         offset = AppData.iphonexOffset
    //     }
    //     if (this._scrollWidth == 0) {
    //         let scrollWidget = this.scrollView.node.getComponent(cc.Widget)
    //         scrollWidget.updateAlignment()
    //         if (AppData.iphonexOffset) {
    //             scrollWidget.left = scrollWidget.left + AppData.iphonexOffset
    //             this.scrollView.node.width = this.scrollView.node.width - AppData.iphonexOffset
    //             // let p = this.scrollView.node.position
    //             // p.x = p.x - AppData.iphonexOffset / 2
    //             // this.scrollView.node.position = p
    //         }
    //         this._scrollWidth = Math.ceil(this.scrollView.node.width)
    //     }

    //     let self = this
    //     let width = this._scrollWidth
    //     let needWidth = self.cellWidth * length + offset
    //     if (width > needWidth) {
    //         self.layout.node.setAnchorPoint(0.5, 0.5)
    //         self.layout.updateLayout()
    //         let pos = self.layout.node.position
    //         pos.x = self.offsetX / 2 - offset
    //         self.layout.node.position = pos
    //     } else {
    //         self.layout.node.setAnchorPoint(0, 0.5)
    //         self.layout.updateLayout()
    //         let pos = self.layout.node.position
    //         pos.x = -width / 2
    //         self.layout.node.position = pos
    //         self.scrollView.scrollToTop()//刷新一下 不然点击列表会自动跳动一下
    //     }
    // }

}
